






import {
    Vue, Component, Prop, Watch,
} from 'vue-property-decorator'

@Component({
    name: 'UploadPlusIcon',
    components: {
    },
})
export default class UploadPlusIcon extends Vue {
    @Prop({default: false}) disabled!: boolean   // 是否禁用

    handleClick() {
        if (!this.disabled) {
            this.$emit('click')
        }
    }
}
